import type { ButtonProps } from 'antd'

export const JUSTIFICATION_BUTTON_VARIANTS = [
  'positive',
  'negative',
  'neutral',
] as const

export type JustificationButtonVariant =
  (typeof JUSTIFICATION_BUTTON_VARIANTS)[number]

/**
 * Maps the semantic variant onto AntD's color/variant pair, so a trigger button
 * and its dialog's submit button always read the same.
 */
export function getJustificationVariantProps(
  variant: JustificationButtonVariant
): Pick<ButtonProps, 'color' | 'variant'> {
  switch (variant) {
    case 'positive':
      return { color: 'green', variant: 'solid' }
    case 'negative':
      return { color: 'danger', variant: 'solid' }
    case 'neutral':
      return { color: 'default', variant: 'outlined' }
  }
}
